import React from 'react'
import { notify } from 'reapop'

import { portuguesVersion } from './../../../../testData/testPlan'
import PatientCreationForm from './PatientCreationForm'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import patients from '../../../../testData/testPatients'
import withPolyglot from '../../../common/withPolyglot'

class PatientCreationContainer extends React.Component {
  handleSubmit ({id, name, birthDate, gender}) {
    patients.push({
      id,
      name,
      birthDate,
      gender,
      photo: `https://cdn.kenetto.com/vaccinapp/imgs/${gender}_symbol.png`,
      plan: portuguesVersion,
      immunizations: [],
      recommendations: []
    })
    this.props.notify({
      message: this.props.translate('addedPatient', true, 'alerts'),
      status: 'success',
      dismissible: true,
      dismissAfter: 3000,
      position: 'bl',
      closeButton: true,
      allowHTML: true,
      buttons: []
    })
  }

  render () {
    return <PatientCreationForm handleSubmit={this.handleSubmit.bind(this)} translate={this.props.translate} />
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({notify}, dispatch)
}

export default connect(null, mapDispatchToProps)(withPolyglot(PatientCreationContainer, 'patientCreation'))
